import { Component, OnInit, AfterContentInit } from '@angular/core';
import { AuthService } from '../../app/auth.service';
import { BaseLoginComponent } from './base-login.component';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { ServiceLocator } from '../ServiceLocator';
import { AppConfiguration } from '../conf/app.configuration';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { clearModalsOnCloseSession } from '../app.helpers';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';

@Component({
  selector: 'forgottenpassword',
  templateUrl: 'forgotten-password-view.template.html'
})
export class ForgottenPasswordViewComponent extends BaseComponent implements OnInit, AfterContentInit {
  background: any;

  private store: Store<AppState>;

  public userOrMail: string;


  errorMsg = '';
  public show_spin = -100;

  constructor(protected authService: AuthService, appConfig: AppConfiguration,
    public translateService: TranslateService, private waitService: WaitLoadingService,
    private plycaErrorHandler: PlycaErrorHandler) {
    super();
    this.store = ServiceLocator.injector.get(Store) as Store<AppState>;
  }

  ngOnInit(): void {
    // al inicializar el componte se genera el background
    this.background = this.calculateBackground();
    clearModalsOnCloseSession();
  }

  onSubmit() {
    if (!this.userOrMail) {
      this.errorMsg = this.translateService.instant('LoginView.forgotten.validUser');
    } else {
      this.show_spin = 100;
      this.subscribe(this.authService.requestResetPassword(this.userOrMail),
        () => {
          this.show_spin = -100;
          this.errorMsg = this.translateService.instant('LoginView.forgotten.mailSent');
        },
        error => {
          this.show_spin = -100;
          this.errorMsg = this.plycaErrorHandler.getErrorMessage(error);

        }
      );
    }
  }

  ngAfterContentInit(): void {

    this.waitService.cancelWaiting();
  }

  public calculateBackground() {
    let min = 1;
    let max = 10;
    let random = Math.floor(Math.random() * (max - min + 1) + min);
    let url = 'assets/img/bg-login' + random + '.jpeg';
    console.log('Calculando background', url);
    return {
      background: 'url(' + url + ') no-repeat'
    };
  }
}
